export enum HttpStatusCode {
	NO_CONTENT = 204,
	UNAUTHORIZED = 401,
	FORBIDDEN = 403,
	NOT_FOUND = 404
}

export enum TypeRequest {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	PATCH = 'PATCH',
	DELETE = 'DELETE'
}

// Auth
export enum AuthLink {
	LOG_IN = '/complete/saml',
	REFRESH = '/complete/refresh',
	TOKEN = '/complete/token'
}

export enum Role {
	ADMIN = 'SbexAdmin',
	USER = 'SbexUser'
}
